import { render, staticRenderFns } from "./IsaacIntegration.vue?vue&type=template&id=3f5e1659&"
import script from "./IsaacIntegration.vue?vue&type=script&lang=js&"
export * from "./IsaacIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports